module.exports = __webpack_public_path__ + "img/logo.a85e94bb.jpeg";